define([
	"dojo/_base/declare",
	"csi/datasheet/SubtypedDataSheet"
], function(declare, SubtypedDataSheet) {

	return declare(SubtypedDataSheet, {

		// view id that is going to be repeated per subtype
		subtypedViewId: "TestsBySection",

		// the name of the relation to the subtyped class
		relationToSubtypedClass: "TestRunSections",

		// the name of the relation from the subtyped class to Subtype
		relationToSubtype: "TestSpecSubtype",

		// the name of the class that has subtypes
		subtypedClassName: "TestSpec",

		// property used in the setViewNode function
		viewNodePropertyName: "urlTestRunSection"

	});
});